import React from "react";

import HGraph from "components/Custom/HGraph";

import { GRAPH_TYPES } from "common/config";

const ColumnGraph = (props: any) => {
  const { height, data } = props;

  const columnChart = data.columnChart;
  const categories = columnChart.category;
  const series = columnChart.data.data;

  return (
    <React.Fragment>
      <div className="graphs">
        <HGraph
          width={"100%"}
          height={height}
          type={GRAPH_TYPES.COLUMN}
          float={"right"}
          title={""}
          xAxis={categories}
          yAxis={series}
          exportTitle={"Column Graph Record"}
          xAxisTitle=""
          yAxisTitle="Leads"
        />
      </div>
    </React.Fragment>
  );
};

export default ColumnGraph;
